import React from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import styled from 'styled-components';
import { formats } from '~/helper';
import Modal from '~/components/modal';
import ImageAuth from '~/components/image';
import { Autocomplete, InputLabel, InputGroup } from '~/components/form';

const Container = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;

  span {
    color: #d61305;
    margin: 0 0 10px;
  }

  img {
    max-width: 100px;
    max-height: 100px;
    align-self: center;
    display: flex;
  }
`;


const EmployeeSchema = Yup.object().shape({
  person: Yup.object().shape({
    role: Yup.mixed().test('', 'Informe a função', function(value) {
      return !_.isEmpty(value);
    }),
    name: Yup.string().required('Informe o colaborador')
  })
});

const EmployeePressSchema = Yup.object().shape({
  tribuna: Yup.string().required('Informe o Tipo de acesso')
});

const renderEmployeeForm = ({ values, previewMode, onListPersons, onListRoles }) => {
  return (
     <Container>
        <Autocomplete
          name='person'
          label="Colaborador"
          minLength={1}
          keyField='id'
          value={values.person}
          disabled={previewMode}
          valueFormat={(row) => `${row.name}`}
          loadData={onListPersons}
          emptyText={'Pesquise um colaborador'}
          tipText={'Digite... '}
          loadingText={'Carregando...'}
          notFoundText={'Não encontrado'}
          />

        <Autocomplete
          name='person.role'
          label="Função"
          minLength={1}
          keyField='id'
          value={_.get(values, 'person.role')}
          disabled={previewMode}
          valueFormat={(row) => `${row.name}`}
          loadData={onListRoles}
          emptyText={'Pesquise uma função'}
          tipText={'Digite... '}
          loadingText={'Carregando...'}
          notFoundText={'Não encontrada'}
          />

        <InputLabel
          label='Email'
          value={_.get(values, 'person.email')}
          />

        <InputLabel
          label='Telefone'
          value={formats.phone(_.get(values, 'person.phone'))}
          />

        { _.get(values, 'person.photo') &&
          <ImageAuth withoutLoading={true} src={(_.get(values, 'person.photo')) ? `/persons/photo/${_.get(values, 'person.photo')}` : ''} />
        }
      </Container>
  );
};

const renderPressDataForm = ({ values, previewMode, errors, touched }) => {
  return (
    <Container>
      <InputGroup
        type="text"
        name="cabine"
        label="Nº Cabine/Tribuna"
        maxLength={100}
        hasError={_.get(errors, 'cabine') && _.get(touched, 'cabine')} />

      <InputGroup
        type="text"
        name="tribuna"
        label="Tipo de acesso"
        maxLength={100}
        hasError={_.get(errors, 'tribuna') && _.get(touched, 'tribuna')} />
    </Container>
  );
};


function EmployeeModal({ title, previewMode, data, isOpen, loading, closeModal, handleOnSubmit, handleCancelling, onListPersons, onListRoles }) {
  let isPress = _.get(data, 'mode') === 'press';

  return (
    <Formik
      enableReinitialize={true}
      initialValues={data}
      validationSchema={isPress ? EmployeePressSchema: EmployeeSchema}
      initialTouched={isPress ? { tribuna: true } : {}}
      onSubmit={handleOnSubmit}
      >
      {({ values, errors, isValid, touched, handleSubmit, handleReset }) => (
        <Modal
          width="400px"
          height={isPress ? "285px" : "500px"}
          open={isOpen}
          hide={closeModal}
          title={title}
          actions={[
            {
              label: 'Cancelar',
              action: () => { handleReset() ; closeModal() },
              disabled: loading
            },
            {
              label: loading ? 'Aguarde...' : 'Salvar',
              action: () => { handleOnSubmit(values); handleReset() },
              type: 'submit',
              primary: true,
              disabled: !isValid || loading || (isPress && !values.cabine && !values.tribuna)
            }
          ]}
          >
          {isPress ? renderPressDataForm({ values, previewMode, errors, touched })
            : renderEmployeeForm({ values, previewMode, onListPersons, onListRoles })
          }
        </Modal>
      )}
    </Formik>
  );
};

export default EmployeeModal;
